export default __webpack_public_path__ + "static/media/Automated Data Extraction.73be4557.png";